import React, { useState, useEffect, useCallback } from 'react';
import { Form, Select, Row } from 'antd';
import { errHandling } from 'utils';
import { debounce } from 'lodash';

import PdButton from 'components/pd-button';
import OrderService from 'services/rent';
const { Option } = Select;

export function AddRentToInspection({ fetchInspection }) {
  const [form] = Form.useForm();
  const [rentOrderList, setRentOrderList] = useState([]);
  const [loadingButton, setLoadingButton] = useState(false);

  async function fetchRentOrderList({ q, limit = 5, cursor } = {}) {
    try {
      const {
        data: { data = [] },
      } = await OrderService.getOrderList({
        q,
        status: 'return_processed',
        limit,
        cursor,
      });
      setRentOrderList(data);
    } catch (error) {
      errHandling(error);
    }
  }

  const handleOnChangeSearch = useCallback(
    debounce((value) => fetchRentOrderList({ q: value }), 1000),
    []
  );

  useEffect(() => {
    fetchRentOrderList();

    return () => handleOnChangeSearch.cancel();
    // eslint-disable-next-line
  }, []);

  async function handleSubmit(values) {
    setLoadingButton(true);
    try {
      await OrderService.sentToInspection(values.id);
      fetchInspection();
    } catch (err) {
      errHandling(err);
    } finally {
      setLoadingButton(false);
    }
  }

  return (
    <Form form={form} layout="vertical" onFinish={handleSubmit}>
      <Form.Item
        label="Order ID"
        name="id"
        rules={[
          {
            required: true,
            message: 'Please input Order ID!',
          },
        ]}>
        <Select
          placeholder="Select Order ID"
          filterOption={false}
          showSearch
          onSearch={handleOnChangeSearch}
          notFoundContent={null}>
          {rentOrderList.map(({ id } = {}) => (
            <Option key={id} value={id}>
              {id}
            </Option>
          ))}
        </Select>
      </Form.Item>
      <Form.Item>
        <Row type="flex" justify="center">
          <PdButton
            className="w-half height-32"
            full
            htmlType="submit"
            loading={loadingButton}
            type="primary">
            Publish
          </PdButton>
        </Row>
      </Form.Item>
    </Form>
  );
}
